var _defs, _path, _path2, _path3, _rect, _text, _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSystlets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "555px",
    height: "654px",
    viewBox: "-0.5 -0.5 555 654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 126.89 181.19 L 170.84 104.86 Q 175.83 96.19 185.83 96.19 L 366.55 96.19 Q 376.55 96.19 381.54 104.86 L 469.45 257.52 Q 474.44 266.19 469.45 274.86 L 381.54 427.52 Q 376.55 436.19 366.55 436.19 L 185.83 436.19 Q 175.83 436.19 170.84 427.52 L 82.93 274.86 Q 77.94 266.19 82.93 257.52 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "#000066",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    transform: "rotate(150,276.19,266.19)",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 226.19 181.19 L 326.19 181.19 L 376.19 266.19 L 326.19 351.19 L 226.19 351.19 L 176.19 266.19 Z",
    fill: "#000099",
    stroke: "#7ea6e0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    transform: "rotate(150,276.19,266.19)",
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 276.19 166.19 L 361.19 215.6 L 276.19 265 L 191.19 215.6 Z",
    fill: "#7ea6e0",
    stroke: "#4d4d4d",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.19,
    y: 545,
    width: 440,
    height: 80,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 438,
      height: 1,
      paddingTop: 585,
      marginLeft: 57
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #003366; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 112,
      fontFamily: "&quot",
      color: "rgb(0, 51, 102)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Systlets")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 276,
    y: 619,
    fill: "#003366",
    fontFamily: "Courier New",
    fontSize: "112px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Systlets"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSystlets);
export default __webpack_public_path__ + "static/media/logo-systlets.d30fa2bed37265af7d372c577d7b2247.svg";
export { ForwardRef as ReactComponent };